// import React from 'react';
import { t } from 'i18next';
import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

const ErrorPage = () => {
  useEffect(() => {}, []);

  let history = useHistory();

  const goToPreviousPath = () => {
    // console.log('this is the use hstory');
    history.goBack();
  };

  return (
    <div class="login-reg-area">
      <div class="container">
        <div class="login-reg-wrap">
          <h1 class="m-auto text-center">Page Not Found </h1>
          <form>
            <div class="form-group">
              <label for="login-email" class="sr-only">
                Username
              </label>
            </div>

            <div class="form-group">
              <div class="row justify-content-between">
                {/* <div class='col-auto'>
									<Link to='/reset-password' href='javascript:void(0);'>
										Forget Password
									</Link>
								</div> */}
              </div>
            </div>

            <h4 class="mt-5 text-center">Error page</h4>
            <p class="mb-5 text-center">
              © 2021 Car Avenue. {t('All Rights Reserved')}. {t('Designed by')}
              Design Master
            </p>

            <button
              type="submit"
              class="btn btn-warning btn-block"
              onSubmit={goToPreviousPath}
            >
              Go Back To Home
            </button>

            <hr class="mt-4 mb-4" />

            <p class="mb-0 text-center">
              Don’t have an account?
              <Link to="/register">Register now!</Link>
              {/* <Link to='/OtpVerification'>Register now!</Link> */}
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
